import { defineStore } from "pinia";
import { clockNudgeConfig } from "@/config/clockNudge";

// Held at module scope (not in state) so Pinia never tries to serialize a function.
let resolver = null;

function settle(value) {
  if (resolver) {
    const r = resolver;
    resolver = null;
    r(value);
  }
}

// Promise-based controller for the "use the mobile app" nudge. A page calls
// `prompt('in' | 'out')` before opening the web clock-in/out flow and awaits the
// result: true => continue in web, false => the user chose download / dismissed.
export const useClockNudgeStore = defineStore("clockNudgeStore", {
  state: () => ({
    visible: false,
    mode: "in",
  }),
  actions: {
    prompt(mode = "in") {
      // Feature flag off → proceed immediately, no modal.
      if (!clockNudgeConfig.enabled) return Promise.resolve(true);
      // If a prompt is somehow already open, resolve it as dismissed first.
      settle(false);
      this.mode = mode === "out" ? "out" : "in";
      this.visible = true;
      return new Promise((resolve) => {
        resolver = resolve;
      });
    },
    continueInWeb() {
      this.visible = false;
      settle(true);
    },
    dismiss() {
      this.visible = false;
      settle(false);
    },
  },
});
